{
  "hero": {
    "title": "Servicii",
    "cta": "Contact"
  },
  "banner": {
    "message": "Disponibil pentru întrebări și briefing-uri.",
    "cta": "Contact"
  },
  "services": [
    {
      "number": "01",
      "title": "Producție de conținut video și fotografie",
      "description": "Veriga lipsă în comunicarea de business. Video și fotografie de înaltă calitate — materiale pe care majoritatea agențiilor le lasă în sarcina clientului.",
      "items": [
        {
          "title": "Videoclipuri corporate",
          "description": "Prezentări de companie, cultură și recrutare — materiale clare pentru web și comunicare internă.",
          "previewVideo": "corporate"
        },
        {
          "title": "Povești de brand",
          "description": "Videoclipuri cinematice care umanizează compania.",
          "previewVideo": "povesti-brand"
        },
        {
          "title": "Videoclipuri demo produs și explicative",
          "description": "Tehnologie complexă, prezentată pe înțelesul publicului.",
          "previewVideo": "demo-produs"
        },
        {
          "title": "Video vertical social-first",
          "description": "Reels, Stories și clipuri TikTok în format portret, din aceeași sesiune de filmare.",
          "previewVideo": "social-first"
        },
        {
          "title": "Fotografie produs și lifestyle",
          "description": "Imagini profesionale pentru website-uri, cataloage, e-commerce și campanii.",
          "previewVideo": "fotografie-produs"
        },
        {
          "title": "Filmări on-location și evenimente",
          "description": "Producție la birou, magazin, cramă sau eveniment live.",
          "previewVideo": "filmari-on-location"
        },
        {
          "title": "Biblioteci de asset-uri",
          "description": "Bancă lunară de fotografii și videoclipuri scurte pentru canale active."
        }
      ]
    }
  ]
}
